export default __webpack_public_path__ + "static/media/logo-maestro.24fcfe75.jpg";